// Theme Core
import './core';
import './global/scroll-to';
//import './global/swiper';
import makeCalcAppHeight from './global/vh-fix';

/* Height fix for mobile browser */
makeCalcAppHeight();
